import React, { useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { LoadingScreen } from '../components/ui'
import { getViolationsFromLink } from '../redux/actions'
import { withRouter } from 'react-router-dom'
import log from 'loglevel'

/**
 * Reads from url params to get authentication token, accountID, and user/supervisorID
 * @returns redirect to application if all params are found, if not then redirects to login
 */
const Links = (props) => {
  const dispatch = useDispatch()

  useMemo(() => {
    const getViolationIDs = async () => {
      if (props.match && props.match.params) {
        const { linkID } = props.match.params
        if (!linkID) {
          log.warn('Could not find params from link')
          // route to default page
        } else {
          log.info('we have all params')
          log.debug(linkID)
          await dispatch(getViolationsFromLink(linkID))
            .catch(err => console.error(err))
          // If we got the violationIDs successfully, route to detail view
          props.history.push({
            pathname: '/captures',
            search: '?view=single&capture=1'
          })
        }
      }
      // await getViolationsFromLink
    }
    getViolationIDs()
  }, [dispatch, props.match, props.history])

  return (<LoadingScreen />)
}

export default withRouter(Links)
